import { Grid } from '@mui/material';
import dayjs from 'dayjs';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sharedActions } from '../../../../redux/slice/shared.slice';
import { userActions } from '../../../../redux/slice/user.slice';
import { CHANGE_MEMBER_STATUS, DELETE_MEMBER, GET_MEMBERS } from '../../../../redux/types/member.types';
import MyDialog from '../../../shared/MyDialog/MyDialog';
import MyTable from '../../../shared/MyTable/MyTable';
import { handleDownloadCsv } from '../../../utils/csv';
import styles from '../../user/user.module.scss';
import { getMemberColumns, memberDownloadCols } from '../helper';
import MemberForm from './MemberForm';
import MemberToolbar from './MemberToolbar';
import SubscriptionForm from './Subscription/SubscriptionForm';
import { uiActions } from '../../../../redux/slice/ui.slice';
import MemberInfo from './MemberInfo/MemberInfo';

const Member = () => {

    const dispatch = useDispatch();
    const [searchTerm, setSearchTerm] = useState("");
    const [userStatus, setUserStatus] = useState("Active");
    const [expiryCheck, setExpiryCheck] = useState(false);


    const handleCallApi = useCallback(({ searchTerm, userStatus, expiryCheck }) => {
        const payload = {
            searchTerm, userStatus, expiryCheck
        }
        dispatch({ type: GET_MEMBERS, payload })
    }, [dispatch])

    const handleChangeStatus = (event) => {
        setUserStatus(event.target.value);
        handleCallApi({ searchTerm: searchTerm, userStatus: event.target.value, expiryCheck: expiryCheck })
    };

    const handleChangeExpiry = (event) => {
        setExpiryCheck(event.target.checked);
        handleCallApi({ searchTerm: searchTerm, userStatus: userStatus, expiryCheck: event.target.checked })
    };

    const handleSearch = (event) => {
        setSearchTerm(event.target?.value);
        handleCallApi({ searchTerm: event.target?.value, userStatus: userStatus, expiryCheck: expiryCheck })
    };

    useEffect(() => {
        handleCallApi({ searchTerm: "", userStatus: "Active", expiryCheck: false })
    }, [dispatch, handleCallApi])

    const members = useSelector(userActions.selectors.getMembers)
    const isModalOpen = useSelector(uiActions.selectors.getMemberPopup);
    const handleModelOpen = () => {
        dispatch(uiActions.actions.setMemberPopup(true))
        dispatch(sharedActions.actions.setCardState("member"))
    }

    const handleModelClose = () => {
        dispatch(uiActions.actions.setMemberPopup(false))
        dispatch(userActions.actions.setEditMemberDataSlice({}))
        dispatch(sharedActions.actions.setCardState("all"))
    }

    const [isVisitOpen, setIsVisitOpen] = useState(false);
    const handleVisitModelOpen = () => {
        setIsVisitOpen(true)
    }

    const handleVisitModelClose = () => {
        setIsVisitOpen(false)
    }
    const [menuState, setMenuState] = useState({
        anchorEl: null,
        selectedRow: null,
    });

    const editUserData = useSelector(userActions.selectors.getEditMemberData)
    const handleOpenMenu = (event, row) => {
        setMenuState({
            anchorEl: event.currentTarget,
            selectedRow: row,
        });
    };

    const handleClose = () => {
        setMenuState({
            anchorEl: null,
            selectedRow: null,
        });
    };



    const handleClickItem = (key, row) => {
        // eslint-disable-next-line default-case
        switch (key) {
            case "Delete":
                const payload = {
                    memberId: row?._id,
                };
                dispatch({ type: DELETE_MEMBER, payload });
                break;
            case "Edit":
                dispatch(userActions.actions.setEditMemberDataSlice(row))
                handleModelOpen()
                break;
            case "Subscription":
                handleSubscriptionModalOpen();
                dispatch(userActions.actions.setEditMemberDataSlice(row))
                break;
            case "Activate":
                dispatch({ type: CHANGE_MEMBER_STATUS, payload: { id: row?._id, status: true } })
                break;
            case "Deactivate":
                dispatch({ type: CHANGE_MEMBER_STATUS, payload: { id: row?._id, status: false } })
                break;
            case "Visit":
                handleVisitModelOpen();
                dispatch(userActions.actions.setSelectedMemberSlice(row))
                break;
        }
        handleClose();
    };

    const [subscriptionModel, setSubscriptionModel] = useState(false)
    const handleSubscriptionModalOpen = () => {
        setSubscriptionModel(true)
    }
    const handleSubscriptionModalClose = () => {
        setSubscriptionModel(false)
    }


    const memberColumns = getMemberColumns({ menuState, handleClose, handleClickItem, handleOpenMenu })
    const selectedMember = useSelector(userActions.selectors.getSelectedMember)


    return (
        <>
            <Grid container className={styles.userContainer}>
                <Grid item xs={12}>
                    <MemberToolbar
                        searchTerm={searchTerm}
                        placeHolder={"Search Member"}
                        handleSearch={handleSearch}
                        text={"Add Member"}
                        handleClickBtn1={handleModelOpen}
                        handleClickBtn2={() => handleDownloadCsv(members, memberDownloadCols, `Members ${dayjs().format("DD_MM_YYYY")}`)}
                        handleFilterChange={handleChangeStatus}
                        userStatus={userStatus}
                        handleChangeExpiry={handleChangeExpiry}
                    />
                </Grid>
                {console.log("members", members)}
                <Grid item xs={12}>
                    <MyTable
                        checkboxSelection={false}
                        columns={memberColumns}
                        rows={members}
                        id={(row) => row?._id}
                    />
                </Grid>
                <MyDialog isFullScreen={true} title={"Add Member"} open={isModalOpen} handleClose={handleModelClose} maxWidth='xl' >
                    <MemberForm editUserData={editUserData} handleClose={handleModelClose} />
                </MyDialog>

                <MyDialog isFullScreen={false} title={"Add Subscription"} open={subscriptionModel} handleClose={handleSubscriptionModalClose} maxWidth='md' >
                    <SubscriptionForm userData={editUserData} handleClose={handleSubscriptionModalClose} />
                </MyDialog>

                <MyDialog maxWidth='xl' title={"Member Information"} open={isVisitOpen} handleClose={handleVisitModelClose}  >
                    <MemberInfo member={selectedMember} handleClose={handleVisitModelClose} />
                </MyDialog>
            </Grid>
        </>
    )
}

export default Member
